import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";

import { Btn, P } from "../../../../../AbstractElements";
import { ALL_USERS_STATUS } from "../../../../../Api/constants";
import BorderTabs from "../../../../../CommonElements/BorderTabs";
import FilterSliderModal from "../../../../../CommonElements/FilterSliderModal";
import LabelTooltip from "../../../../../CommonElements/LabelTooltip";
import MultiFileUpload from "../../../../../CommonElements/MultiFileUpload/MultiFileUpload";
import MultiSelectDropdown from "../../../../../CommonElements/MultiSelectDropdown";
import EmployeeList from "../../../../../container/EmployeeList";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../ReduxToolkit/Hooks";
import { bulkUploadUsers } from "../../../../../ReduxToolkit/Reducers/AssessmentCatlogSlice";
import {
  getFilterRolesList,
  getSbuList,
  getUserMasterList,
} from "../../../../../ReduxToolkit/Reducers/MasterSlice";
import { dynamicImage } from "../../../../../Service";
import {
  DownloadTemplate,
  GroupSelectUsersTooltipMessage,
  JobRole,
  SBU,
  SearchForUsersOrGroups,
  Select,
  Template,
  Upload,
  UploadFile,
  Users,
} from "../../../../../utils/Constant";
import { userGroupTabs } from "../../../../../utils/helper/helper";

const AddUser = ({ addedUsers, setAddedUsers, setAddedUsersCards }) => {
  const { roleOnFilter, sbuList, userMasterList } = useAppSelector(
    state => state.master
  );
  const { urlList } = useAppSelector(state => state.user);
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState<string>("select_users");
  const [usersList, setUsersList] = useState([]);
  const [roleFilterList, setRoleFilterList] = useState([]);
  const [sbuFilterList, setSbuFilterList] = useState([]);
  const [preSelectedUsers, setPreSelectedUsers] = useState([]);
  const [userCardDetailIds, setUserCardDetailIds] = useState([]);
  const [userCardDetail, setUserCardDetail] = useState([]);
  const [enrolledUsersIds, setEnrolledUsersIds] = useState([]);
  const [flushData, setFlushData] = useState(false);
  const [uploadFile, setUploadFile] = useState([]);
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [defaultFilterValues, setDefaultFilterValues] = useState({});

  useEffect(() => {
    dispatch(
      getUserMasterList({
        roleId: null,
        sbuId: null,
        type: ALL_USERS_STATUS?.toString(),
      })
    );
    dispatch(getFilterRolesList());
    dispatch(getSbuList());
    setEnrolledUsersIds([]);
  }, [dispatch]);

  useEffect(() => {
    const value = [];
    const nameMap = {};
    if (userMasterList) {
      userMasterList?.users?.forEach((item: any) => {
        nameMap[item?.id] = item;
        value.push({
          name: item?.id,
          label: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
          value: `${item?.user_name} - ${item?.employee_code || "-"} - ${item?.email || "-"}`,
        });
      });
    }
    setUsersList(value);
  }, [userMasterList]);

  useEffect(() => {
    const value = [];
    if (roleOnFilter) {
      roleOnFilter?.job_role?.forEach(item => {
        value.push({
          name: item?.id,
          label: item?.name,
          value: item?.name,
        });
      });
    }
    setRoleFilterList(value);
  }, [roleOnFilter]);

  useEffect(() => {
    const value = [];
    if (sbuList) {
      sbuList?.sbu?.forEach(item => {
        value.push({
          name: item?.id,
          label: item?.name,
          value: item?.name,
        });
      });
    }
    setSbuFilterList(value);
  }, [sbuList]);

  const handleTabClick = (tabId: any) => {
    setActiveTab(tabId);
  };

  const setMultiDropdownData = (value: any[]) => {
    const usersMap = [];

    usersList?.forEach((element: any) => {
      if (value.includes(element.name)) {
        usersMap.push({
          name: element.name,
          value: element.label,
          label: element.label,
        });
      }
    });
    setPreSelectedUsers(usersMap);
  };

  const onUploadFile = async () => {
    const postData = new FormData();
    uploadFile.forEach(file => {
      postData.append("file", file[0]);
    });
    const ids = [];
    const enrolled = await dispatch(bulkUploadUsers({ file: postData }));
    const userData = [];
    if (enrolled?.payload?.users) {
      setFlushData(true);
      const existingUserIds = userCardDetail.map(user => user.id);
      enrolled?.payload?.users?.map(item => {
        if (
          !enrolledUsersIds.includes(item.id) &&
          !existingUserIds.includes(item.id)
        ) {
          ids.push(item?.id);
          userData.push({
            imagePath:
              item?.profile_url || dynamicImage("profile/user_profile.png"),
            name: item.user_name,
            detail: "",
            empId: item?.employee_code,
            phoneNumber: item?.phone,
            id: item.id,
            sbuName: item?.sbu,
            rmName: item?.mapped_rm?.[0]?.name,
            rmPhone: item?.mapped_rm?.[0]?.rm_phone,
          });
        }
      });
    }
    setUploadFile([]);
    setUserCardDetailIds([...userCardDetailIds, ...ids]);
    setAddedUsers([...userCardDetailIds, ...ids]);
    setUserCardDetail([...userCardDetail, ...userData]);
    setAddedUsersCards([...userCardDetail, ...userData]);
  };

  const handleDone = async (values: { [key: string]: string[] }) => {
    if (values["role"] || values["sbu"]) {
      await dispatch(
        getUserMasterList({
          roleId: values["role"]?.toString(),
          sbuId: values["sbu"]?.toString(),
          type: ALL_USERS_STATUS?.toString(),
        })
      );
    }
  };

  const handleClear = async () => {
    setUsersList([]);
    setPreSelectedUsers([]);
    setUserCardDetail([]);
    setAddedUsersCards([]);
    setUserCardDetailIds([]);
    await dispatch(
      getUserMasterList({
        roleId: null,
        sbuId: null,
        type: ALL_USERS_STATUS?.toString(),
      })
    );
    setSelectedFilterValues({});
    setDefaultFilterValues({});
  };

  return (
    <div>
      <BorderTabs
        tabs={userGroupTabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        showCard={false}
      />

      {activeTab === "select_users" && (
        <Row className="mt-3">
          <Col lg="6" md="6" sm="11" xs="11">
            <LabelTooltip
              label={Users}
              tooltipText={GroupSelectUsersTooltipMessage}
              important
            />

            <MultiSelectDropdown
              onChange={setMultiDropdownData}
              options={usersList?.filter(
                item =>
                  !addedUsers?.includes(item?.name) &&
                  !userCardDetailIds?.includes(item?.name) &&
                  !enrolledUsersIds?.includes(item?.name)
              )}
              placeholder={SearchForUsersOrGroups}
              defaultSelected={preSelectedUsers}
              onBlurDropdown={values => {
                const selected = [];
                values?.forEach(item => {
                  selected.push(item?.name);
                });

                const userData = [];
                const userIds = [];
                userMasterList?.users?.forEach((element: any) => {
                  if (selected.includes(element.id)) {
                    userIds.push(element.id);
                    userData.push({
                      imagePath:
                        element?.profile_url ||
                        dynamicImage("profile/user_profile.png"),
                      name: element.user_name,
                      detail: "",
                      empId: element?.employee_code,
                      phoneNumber: element?.phone,
                      id: element.id,
                      sbuName: element?.sbu,
                      rmName: element?.mapped_rm?.[0]?.name,
                      rmPhone: element?.mapped_rm?.[0]?.rm_phone,
                    });
                  }
                });
                setUserCardDetailIds([...userCardDetailIds, ...userIds]);
                setAddedUsers([...userCardDetailIds, ...userIds]);
                setUserCardDetail([...userCardDetail, ...userData]);
                setAddedUsersCards([...userCardDetail, ...userData]);

                setPreSelectedUsers([]);
              }}
            />
          </Col>
          <Col lg="1" md="1" sm="1" xs="1">
            <div className="filter-margin">
              <FilterSliderModal
                dropdowns={[
                  {
                    label: JobRole,
                    key: "role",
                    tooltipText: `${Select} ${JobRole}`,
                    options: roleFilterList,
                    isMultiSelect: true,
                  },
                  {
                    label: SBU,
                    key: "sbu",
                    tooltipText: `${Select} ${SBU}`,
                    options: sbuFilterList,
                    isMultiSelect: true,
                  },
                ]}
                selectedFilterValues={selectedFilterValues}
                defaultFilterValues={defaultFilterValues}
                setSelectedFilterValues={setSelectedFilterValues}
                setDefaultFilterValues={setDefaultFilterValues}
                onDone={handleDone}
                onClear={handleClear}
              />
            </div>
          </Col>
        </Row>
      )}

      {activeTab === "upload_user" && (
        <div className="mt-3 mb-3">
          <LabelTooltip label={UploadFile} tooltipText={UploadFile} important />
          <div className="d-flex gap-4">
            <P>{Template}</P>
            <a href={urlList?.data?.templates?.email_template || ""} download>
              <P className="primary-text-color">{DownloadTemplate}</P>
            </a>
          </div>
          <MultiFileUpload
            flushData={flushData}
            accept=".csv"
            multiple={false}
            onFileChange={(file, status) => {
              if (flushData) {
                setFlushData(false);
              }
              if (status === "removed") {
                if (uploadFile)
                  setUploadFile(prevDocuments =>
                    prevDocuments.filter(item => item[0].name !== file.name)
                  );
              } else if (status === "done" && file) {
                setUploadFile(prevDocuments => [
                  ...(Array.isArray(prevDocuments) ? prevDocuments : []),
                  [file],
                ]);
              }
            }}
          />
          {uploadFile?.length > 0 && (
            <div className="mt-3">
              <Btn color="primary" onClick={onUploadFile}>
                {Upload}
              </Btn>
            </div>
          )}
        </div>
      )}

      <Row>
        <Col lg="10" md="10" sm="12" xs="12" className="my-3">
          <EmployeeList
            onParticipantDelete={id => {
              const updatedIds = userCardDetailIds?.filter(item => item !== id);
              setUserCardDetailIds(updatedIds);
              setAddedUsers(updatedIds);

              const updatedUsers = userCardDetail.filter(
                user => user.id !== id
              );
              setUserCardDetail(updatedUsers);
              setAddedUsersCards(updatedUsers);
            }}
            userCardWithDetail={userCardDetail}
            showCard={false}
            deleteParticipant={true}
          />
        </Col>
      </Row>
    </div>
  );
};

AddUser.propTypes = {
  addedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setAddedUsers: PropTypes.func.isRequired,
  setAddedUsersCards: PropTypes.func,
};

export default AddUser;
